export const setPrimaryProfile = (primary_profile: {}) => {
  return {
    type: "SET_PRIMARY_PROFILE",
    primary_profile,
  };
};
export const setDeepLink = (payload: {}) => {
  return {
    type: "UPDATE_DEEPLINK_OBJECT",
    payload,
  };
};

export const setProfileImage = (profileImage: string) => {
  return {
    type: "SET_PROFILE_IMAGE",
    profileImage,
  };
};

export const isProfileFetched = (isProfileFetched: boolean) => {
  return {
    type: "IS_PROFILE_FETCHED",
    isProfileFetched,
  };
};

export const areProfileImageFetched = (areProfileImageFetched: boolean) => {
  return {
    type: "ARE_PROFILE_IMAGE_FETCHED",
    areProfileImageFetched,
  };
};

export const isPrimaryProfileFetched = (isPrimaryProfileFetched: boolean) => {
  return {
    type: "IS_PRIMARY_PROFILE_FETCHED",
    isPrimaryProfileFetched,
  };
};

export const setFamilyUserId = (family_user_id: number) => {
  return {
    type: "SET_FAMILY_USER_ID",
    family_user_id,
  };
};

export const setFamilyJioId = (family_jio_id: string) => {
  return {
    type: "SET_FAMILY_JIO_ID",
    family_jio_id,
  };
};

export const setFamilyMPIN = (family_mpin: string) => {
  return {
    type: "SET_FAMILY_MPIN",
    family_mpin,
  };
};

export const setFamilyMobileNo = (family_mobile_no: string) => {
  return {
    type: "SET_FAMILY_MOBILE_NO",
    family_mobile_no,
  };
};

export const setServiceProviderId = (id: number) => {
  return {
    type: "UPDATE_PARTNER_ID",
    id,
  };
};

export const cart_Count = (cart_count: number) => {
  return {
    type: "GET_ITEMS_COUNT",
    cart_count,
  };
};

export const setNextEnabledDate = (nextDate: string) => {
  return {
    type: "SET_ENABLED_DATE",
    nextDate,
  };
};

export const setSelectedDate = (selectedDate: string) => {
  return {
    type: "SET_SELECTED_DATE",
    selectedDate,
  };
};

export const setPayableCharge = (PayableCharge: number) => {
  return {
    type: "SET_PAYABLE_CHARGE",
    PayableCharge,
  };
};

export const setSpecialDiscountValue = (discountValue: number) => {
  return {
    type: "DISCOUNT_VALUE",
    discountValue,
  };
};

export const setSubTotalValue = (subtotal: number) => {
  return {
    type: "SUBTOTAL_VALUE",
    subtotal,
  };
};

export const setDefaultAddress = (address: string) => {
  return {
    type: "SET_ADDRESS",
    address,
  };
};

export const setAddressId = (addressId: string) => {
  return {
    type: "SET_ADDRESS_ID",
    addressId,
  };
};

export const setPincode = (pincode: string) => {
  return {
    type: "SET_PINCODE",
    pincode,
  };
};

export const setCityName = (cityName: string) => {
  return {
    type: "SET_CITYNAME",
    cityName,
  };
};

export const setPackageIds = (packageIds: string) => {
  return {
    type: "SET_PACKAGEID",
    packageIds,
  };
};

export const _setCurrentProfile = (jioId: string) => {
  return {
    type: "SET_CURRENT_PROFILE",
    jioId,
  };
};

export const _setCurrentProfileDataAction = (current_profile_data: {}) => {
  return {
    type: "SET_CURRENT_PROFILE_DATA",
    current_profile_data,
  };
};

export const _setPrimaryProfileRelationshipArrayAction = (ppra: {}) => {
  return {
    type: "SET_PRIMARY_PROFILE_RELATIONSHIP_ARRAY",
    ppra,
  };
};

export const _setSmartSwitchStatus = (status: {}) => {
  return {
    type: "UPDATE_SMART_SWITCH_STATUS",
    status,
  };
};

export const _setBookAppointmentFilterData = (filterData: {}) => {
  return {
    type: "UPDATE_BOOK_APPOINTMENT_FILTER_DATA",
    filterData,
  };
};

export const _setHelpAndSupportOpenStatus = (status: boolean) => {
  return {
    type: "UPDATE_HELP_AND_SUPPORT_OPEN_STATUS",
    status,
  };
};
